import { TextField, Typography, Button } from '@mui/material';
import OtpInput from './otpinput';
import { roundedFieldSx } from '../shared/authFieldStyles';

const SignupFormPhone = ({ formData, handleChange, otpSent, timer, handleSubmit }) => {
  return (
    <>
      <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 1 }}>Phone Number</Typography>
      <TextField
        name="phone_number"
        fullWidth
        margin="normal"
        value={formData.phone_number}
        onChange={handleChange}
        sx={roundedFieldSx}
      />

      {otpSent && (
        <>
          <OtpInput />
          <Button disabled={timer > 0}>
            Resend OTP {timer > 0 ? `in ${timer}s` : ''}
          </Button>
        </>
      )}

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ borderRadius: '30px', mt: 2 }}
        onClick={handleSubmit}
      >
        Create Account
      </Button>
    </>
  );
};

export default SignupFormPhone;
